import { FinancialPeriod, Result } from "../models/interfaces";
import { BaseService } from "./BaseService";

export class FinancialPeriodService extends BaseService {
  async getPeriods(): Promise<Result<FinancialPeriod[]>> {
    return this.get("financialYears");
  }

  async getPeriod(id: number): Promise<Result<FinancialPeriod>> {
    return this.get(`financialYears/${id}`);
  }

  async deletePeriod(id: number): Promise<Result<FinancialPeriod>> {
    return this.delete(`financialYears/${id}`);
  }

  async createOrUpdatePeriod(
    params: {
      name?: string;
      fromDate?: Date | null;
      toDate?: Date | null;
    },
    id?: number
  ): Promise<Result<FinancialPeriod | boolean>> {
    if (id) {
      return this.put(`financialYears/${id}`, params);
    } else {
      return this.post("financialYears", params);
    }
  }
}

export default new FinancialPeriodService();
